import * as React from "react";
import styled from "styled-components";
import { SvgCitoyens } from "./words/Citoyens";
import { SvgClimat } from "./words/Climat";
import { SvgCreation } from "./words/Creation";
import { SvgDesigners } from "./words/Designers";
import { SvgEngages } from "./words/Engages";
import { SvgHorizons } from "./words/Horizons";
import { SvgImpact } from "./words/Impact";
import { SvgSens } from "./words/Sens";
import { SvgStrategie } from "./words/Strategie";
import { SvgTechnologie } from "./words/Technologie";
import { SvgTransition } from "./words/Transition";
import { SvgCExpMark } from "./words/CExpMark";
import { SvgDeveloppeurs } from "./words/Developpeurs";
import { SvgCommunicants } from "./words/Communicants";

const Map = {
  ["citoyens"]: SvgCitoyens,
  ["climat"]: SvgClimat,
  ["création"]: SvgCreation,
  ["c !"]: SvgCExpMark,
  ["designers"]: SvgDesigners,
  ["engagés"]: SvgEngages,
  ["horizons"]: SvgHorizons,
  ["impact"]: SvgImpact,
  ["sens"]: SvgSens,
  ["stratégie"]: SvgStrategie,
  ["technologie"]: SvgTechnologie,
  ["transition"]: SvgTransition,
  ["developpeurs"]: SvgDeveloppeurs,
  ["communicants"]: SvgCommunicants,
};

interface Props {
  word: string;
  color: string;
}

const I = styled.i`
  position: relative;
`;

export const Word = ({ word, color }: Props) => {
  const SvgWord = Map[word];

  return (
    <I style={{ color: SvgWord ? "transparent" : "inherit" }}>
      {word}
      {SvgWord && (
        <SvgWord
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            height: "100%",
            width: "100%",
            color,
            pointerEvents: "none",
            transform: "translate(-50%, -50%)",
          }}
        />
      )}
    </I>
  );
};
